import api from './api';

const taxFormsService = {
  // Get all tax forms for an agent
  getAgentTaxForms: async (agentId) => {
    const response = await api.get(`/tax-forms/agent/${agentId}`);
    return response.data;
  },

  // Get all tax forms for current agent
  getAll: async (type = null) => {
    const params = type ? { type } : {};
    const response = await api.get('/tax-forms', { params });
    return response.data;
  },

  // Upload tax form
  uploadTaxForm: async (agentId, formData) => {
    const response = await api.post(`/tax-forms/agent/${agentId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Submit W-9 form
  submitW9: async (formData) => {
    const payload = {
      form_type: 'W-9',
      form_data: formData,
      digital_signature: formData.digitalSignature || formData.signature
    };
    const response = await api.post('/tax-forms', payload);
    return response.data;
  },

  // Submit W-8BEN form
  submitW8BEN: async (formData) => {
    const payload = {
      form_type: 'W-8BEN',
      form_data: formData,
      digital_signature: formData.digitalSignature || formData.signature
    };
    const response = await api.post('/tax-forms', payload);
    return response.data;
  },

  // Generate 1099 forms
  generate1099: async (agentId, year) => {
    const response = await api.post(`/tax-forms/generate-1099/${agentId}`, { year });
    return response.data;
  },

  // Download tax form
  downloadTaxForm: async (formId) => {
    const response = await api.get(`/tax-forms/${formId}/download`, {
      responseType: 'blob'
    });
    return response;
  },

  // Download form (alias for backward compatibility)
  download: async (formId) => {
    return taxFormsService.downloadTaxForm(formId);
  }
};

export default taxFormsService;
